import {NgModule} from '@angular/core';
import {SitePreviewComponent} from './site-preview/site-preview';
import {SiteFormComponent} from './site-form/site-form';
import {RoutePathViewerComponent} from './route-path-viewer/route-path-viewer';
import {SectorPreviewComponent} from './sector-preview/sector-preview';
import {RoutePreviewComponent} from './route-preview/route-preview';
import {CommonModule} from "@angular/common";
import {IonicModule} from "ionic-angular";
import {QuillModule} from "ngx-quill";
import {YagaModule} from "@yaga/leaflet-ng2";
import {PinchToZoomComponent} from "./pinch-to-zoom/pinch-to-zoom";
import { TextEditorComponent } from './text-editor/text-editor';
import { ExpandableComponent } from './expandable/expandable';

@NgModule({
	declarations: [SitePreviewComponent,
    SiteFormComponent,
    RoutePathViewerComponent,
    SectorPreviewComponent,
    RoutePreviewComponent,
    RoutePathViewerComponent,
    PinchToZoomComponent,
    TextEditorComponent,
    ExpandableComponent
  ],
	imports: [
    CommonModule,
    IonicModule,
    QuillModule,
    YagaModule,
  ],
	exports: [SitePreviewComponent,
    SiteFormComponent,
    RoutePathViewerComponent,
    SectorPreviewComponent,
    RoutePreviewComponent,
    RoutePathViewerComponent,
    PinchToZoomComponent,
    TextEditorComponent,
    ExpandableComponent,
  ]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts